import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Schedule from "./pages/Schedule";
import Events from "./pages/Events"
import Event from "./pages/Event";
import Collusion from "./pages/Collusion";
import ArcadeAntics from "./pages/ArcadeAntics";
import BoredRoom from "./pages/BoredRoom";
import SpaceshipControl from "./pages/SpaceshipControl";
import NotFound from "./pages/NotFound";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import Layout from "./components/Layout";
import { GlobalProvider } from "./context/GlobalContext";

import './styles.css'

export default function App() {
  return (
    <GlobalProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/schedule" element={<Schedule />} />

          {/* events */}

          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<Event />} />

          {/* shop */}
          <Route path="/shop/collusion" element={<Collusion />} />

          {/* arcade antics */}
          <Route path="/arcade-antics" element={<ArcadeAntics />} />
          <Route path="/arcade-antics/bored-room" element={<BoredRoom />} />
          <Route path="/arcade-antics/spaceship-control" element={<SpaceshipControl />} />

          {/* checkout */}
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </GlobalProvider>
  );
}
